import React, { useContext, useEffect, useMemo } from "react";
import PmoTooltip from "../../ProductMarketingOptimization/components/common/PmoTooltip";
import { ThemeContext } from "../../../context";
import { RootStateOrAny, useSelector } from "react-redux";
import { ErrorBoundary } from "@sentry/react";
import { ErrorMsg, NoDataMsg } from "../../../components/AppMessages";
import BrandPerformanceTrendChart from "../../../components/Charts/BrandPerformance/BrandPerformanceTrendChart";
import LoadingEllipsis from "../../../components/Loading/LoadingEllipsis";
import CompetitorSelect from "./competitorSelect";

interface Props {
  title: string;
  chartId: string;
  chartData: any;
  TrendTooltipParagraph?: () => JSX.Element;
  loadingTrend: boolean;
  diff: number;
  nissanCompetitor?: string;
  onHandleRadioClick?: () => void;
  isPercentage?: boolean;
  chartLegendPosition?: "right" | "left" | "top" | "bottom";
  showSOVchartText?: boolean;
  showTPVAchartText?: boolean;
  numberFormat?: string;
  chartGranularity?: string;
  noValueAxisMin?: boolean;
}

const BrandPerformanceTrendTile = (props: Props) => {
  const { theme } = useContext(ThemeContext);
  const { granularity, market } = useSelector((state: RootStateOrAny) => state.parameters);
  const {
    title,
    chartId,
    chartData,
    TrendTooltipParagraph,
    loadingTrend,
    diff,
    nissanCompetitor,
    onHandleRadioClick,
    isPercentage,
    chartLegendPosition = "top",
    showSOVchartText = false,
    showTPVAchartText = false,
    numberFormat,
    chartGranularity,
    noValueAxisMin
  } = props;

  const topModels = useMemo(() => {
    return chartData?.series?.slice(-10)?.map((series: { name: any }) => series?.name);
  }, [chartData]);

  return (
    <>
      <div className="primary_background ">
        <div className="header" style={{ paddingTop: "1em", paddingLeft: "1em" }}>
          <div className="title_container">
            <>
              <h3>{title}</h3>
              {TrendTooltipParagraph && <PmoTooltip paragraphs={<TrendTooltipParagraph />} />}
            </>
            {nissanCompetitor && <CompetitorSelect onHandleRadioClick={onHandleRadioClick} nissanCompetitor={nissanCompetitor} />}
          </div>
        </div>
        <div className="chart_content">
          {chartData?.data?.length && !loadingTrend ? (
            <ErrorBoundary fallback={<ErrorMsg />}>
              <BrandPerformanceTrendChart
                theme={theme}
                chartId={chartId}
                granularity={chartGranularity ? chartGranularity : granularity}
                seriesList={chartData.series}
                data={chartData.data}
                market={market}
                diff={diff}
                percentageChart={isPercentage}
                legendPosition={chartLegendPosition}
                showSOVchartText={showSOVchartText}
                showPTVAchartText={showTPVAchartText}
                numberFormat={numberFormat}
                axisRangeValue={title == "TPVA Trend" ? 100 : null}
                noValueAxisMin={true}
              />
            </ErrorBoundary>
          ) : loadingTrend ? (
            <LoadingEllipsis isLoading={loadingTrend} />
          ) : (
            <NoDataMsg message="No data available" />
          )}
        </div>
      </div>
    </>
  );
};

export default BrandPerformanceTrendTile;
